import React from 'react';
import ReactLink from '@client/components/reactLink/ReactLink';
import styles from './softOptInPhoneNumberPolicyText.scss';

function SoftOptInPhoneNumberPolicyText() {
  return (
    <div className={styles.policyText}>
      Vi kan komma att höra av oss till dig via sms med information om hur du
      kan stödja forskningen. Vill du veta mer om hur vi behandlar dina
      personuppgifter? Läs mer i vår{' '}
      <ReactLink
        to={'https://www.hjart-lungfonden.se/om-oss/dataskydd/'}
        className={`${styles.policyLink}`}
      >
        dataskyddspolicy
      </ReactLink>
      .
    </div>
  );
}

export default SoftOptInPhoneNumberPolicyText;
